import React from "react";
import MaterialCircle from "./materialCircle";

import { StyledFragmentSpinner } from "./styledSpinner";

const FragmentSpinner = ({ position }) => {
  return (
    <StyledFragmentSpinner position={position}>
      <MaterialCircle />
    </StyledFragmentSpinner>
  );
};

export default FragmentSpinner;